import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.storage.objectstore.delete;

const {
	actions,
	reducer,
	sagas,
	additionalSagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORAGE_OBJECTSTORE_DELETE',
	method: 'POST',
	url: '/storage/objectstore/delete.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, additionalSagas, selectors };
